/**
 * Help-agent API module — the in-product AI help chat.
 * One endpoint: POST /help-agent/chat. First message omits conversationId
 * (creates the conversation); later turns pass it back to append.
 */
import { fetchApi } from './client';
import { log } from '@/lib/logger';

log.info('[api/helpAgent] Module loaded');

export interface HelpChatInput {
  /** Omit on the first message; returned by the server and echoed back after. */
  conversationId?: string;
  /** The user's message, 1–2000 chars (server-validated). */
  message: string;
}

export interface HelpChatResponse {
  conversationId: string;
  reply: string;
  signal: 'none' | 'feedback' | 'bug' | 'frustration' | 'unanswered';
}

export const helpAgentApi = {
  /** Send one chat turn. Requires an authenticated user. */
  chat: (token: string, input: HelpChatInput): Promise<HelpChatResponse> =>
    fetchApi<HelpChatResponse>('/help-agent/chat', {
      token,
      method: 'POST',
      body: JSON.stringify(input),
    }),
};
